import * as R from 'ramda'
import {
  Maybe,
  // eslint-disable-next-line no-unused-vars
  Wizard,
} from '@domain' // eslint-disable-line

/**
 * @param {Wizard} state
 * @return {Array<{title:string, to:string, content: any[]}>}
 */
export function computeWizardProgress(state) {
  let arr = []
  R.map(cPattern => {
    arr.push({
      title: 'Chart Type',
      content: [cPattern.displayText()],
      to: '/dataViz/wizard/breakdown',
    })
    // @ts-ignore
  })(state.chartPattern)
  R.map(cSelection => {
    let base = [
      {
        title: 'Regions',
        to: '/dataViz/wizard/choose-regions',
      },
      {
        title: 'Region',
        to: '/dataViz/wizard/choose-single-region',
      },
      {
        title: 'Districts',
        to: '/dataViz/wizard/choose-districts',
      },
      {
        title: 'District',
        to: '/dataViz/wizard/choose-single-district',
      },
      {
        title: 'Campuses',
        to: '/dataViz/wizard/choose-campuses',
      },
    ]
    let extracts = [
      cSelection['regions'] ||
        (cSelection._name === 'Regions' && cSelection[0]),
      cSelection['region'],
      cSelection['districts'] ||
        (cSelection._name === 'Districts' && cSelection[0]),
      cSelection['district'],
      cSelection['campuses'] ||
        (cSelection._name === 'Campuses' && cSelection[0]),
    ]
    let f = (e, b) => {
      return R.pipe(
        v => (v === false ? Maybe.Nothing : Maybe.of(v)),
        // @ts-ignore
        R.map(v => ({
          content: R.is(Array, v) ? v : [v.name],
          ...b,
        })),
        R.map(v => arr.push(v))
      )(e)
    }
    R.zipWith(f, extracts, base)
    // @ts-ignore
  })(state.chartSelection)

  return arr
}

/**
 * @param {Wizard} state
 * @return {number}
 */
export function computeWizardStepsNeeded(state) {
  let count = 0
  R.map(cType => {
    // @ts-ignore
    cType.getMetrics().map(_ => (count = count + 1))
  }, state.chartType)
  R.map(cPattern => {
    count =
      count +
      // @ts-ignore
      cPattern.case({
        StateVsRegions: () => 2,
        Regions: () => 2,
        RegionVsDistricts: () => 3,
        Districts: () => 2,
        DistrictVsCampuses: () => 3,
        Campuses: () => 2,
      })
  }, state.chartPattern)

  return count
}
